<template>
  <div class="fund">
          <article>
            <h3><span>{{ title }}</span><em v-if="score > 0" style=" font-size: 18px;width: 100px;flex-shrink: 0;text-align: right;">已得 {{ score }} 分</em></h3>
            <div class="questions" v-if="table" v-html="table"></div>
            <div class="questions" v-if="questions" v-html="questions"></div>
            <div>
              <van-radio-group
                v-model="checked"
                v-for="(item, index) in fundOptions"
                :key="index"
                @change="changeRadio"
              >
                <van-radio
                  :name="index + 1"
                  :label-disabled="labelDisabled"
                  v-if="item != ''"
                  >{{ item }}</van-radio
                >
              </van-radio-group>
            </div>
            <div class="explain" v-if="labelDisabled && explain !== ''" v-html="explain"></div>
          <div class="btn" @click="clickNext">
            {{ btnLable }}
          </div>
        </article>
      </div>
</template>

<script>
import menu from "@/utils/fund/menu";
import fundArr1 from "@/utils/fund/2025/flfg";
import fundArr2 from "@/utils/fund/2025/jjjc";
import fundArr3 from "@/utils/fund/2021/flfg";
import fundArr4 from "@/utils/fund/2021/flfg2";
import fundArr2024501 from "@/utils/fund/2024/5/flfg-1";
import fundArr2024502 from "@/utils/fund/2024/5/flfg-2";
import fundArr2024503 from "@/utils/fund/2024/5/flfg-3";
import fundArr2024504 from "@/utils/fund/2024/5/flfg-4";
import fundArr2024505 from "@/utils/fund/2024/5/flfg-5";
import fundArr2024506 from "@/utils/fund/2024/5/flfg-6";
import fundArr2024507 from "@/utils/fund/2024/5/jjjc-1";
import fundArr2024508 from "@/utils/fund/2024/5/jjjc-2";
import fundArr2024509 from "@/utils/fund/2024/5/jjjc-3";
import fundArr2024510 from "@/utils/fund/2024/5/jjjc-4";
import fundArr2024511 from "@/utils/fund/2024/5/jjjc-5";
import fundArr2024512 from "@/utils/fund/2024/5/jjjc-6";
import fundArr2024513 from "@/utils/fund/2024/5/smgq-1";
import fundArr2024514 from "@/utils/fund/2024/5/smgq-2";
import fundArr2024515 from "@/utils/fund/2024/5/smgq-3";
import fundArr2024516 from "@/utils/fund/2024/5/smgq-4";
import fundArr2024517 from "@/utils/fund/2024/5/smgq-5";
import fundArr2024518 from "@/utils/fund/2024/5/smgq-6";
import fundArr2024519 from "@/utils/fund/2024/11/flfg-1";
import fundArr2024520 from "@/utils/fund/2024/11/flfg-2";
import fundArr2024521 from "@/utils/fund/2024/11/flfg-3";
import fundArr2024522 from "@/utils/fund/2024/11/flfg-4";
import fundArr2024523 from "@/utils/fund/2024/11/jjjc-1";
import fundArr2024524 from "@/utils/fund/2024/11/jjjc-2";
import fundArr2024525 from "@/utils/fund/2024/11/jjjc-3";
import fundArr2024526 from "@/utils/fund/2024/11/jjjc-4";
import fundArr2024527 from "@/utils/fund/2024/11/smgq-1";
import fundArr2024528 from "@/utils/fund/2024/11/smgq-2";
import fundArr2024529 from "@/utils/fund/2024/11/smgq-3";
import fundArr2024530 from "@/utils/fund/2024/11/smgq-4";
import { Notify } from "vant";
export default {
  name: "fund",
  data() {
    return {
      title: "",
      checked: "",
      checkedArr: [],
      name:'',
      id: 1,
      score: 0,
      listData: [],
      questions:'',
      table:'',
      fundOptions: [],
      fundOptionsArr: [],
      antrue: 0,
      explain: "",
      type: 0,
      image: "",
      labelDisabled: false,
      fundType: 0,
      navTitle: "",
      btnLable: "下一题",
      menuOptions: [],
      menuOptions2: menu.data,
      state: this.$route.query.state
    };
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#2c2e2f");
  },
  mounted() {
    this.getUrlName()
  },
  methods: {
    getUrlName() {
      const get_href = window.location.href;
      const get_indexof = get_href.lastIndexOf("/");
      const get_indexText = get_href.substring(get_indexof + 1);
      const get_htmlBeforeText = get_indexText.indexOf(".html");
      this.name = get_indexText.substring(0, get_htmlBeforeText);
      if(this.name !== ''){
        this.changeMenu(this.name)
      }
    },
    changeMenu(val) {
      this.id = 0;
      this.navTitle = this.menuOptions2.filter(item=> item.name === val)[0].label
      document.title =  this.navTitle + '-基金模拟在线题库-呱呱工具箱';
      this.btnLable = "下一题";
      this.getListData();
    },
    processFundData(fundArr) {
      const fundData = [];
      fundArr.fund.forEach(item => {
        fundData.push({
          ...item,
          question: item.question ? item.question.split('\n') : ''
        });
      });
      return fundData;
    },
    getListData() {
      const fundArrs = [
        fundArr1,fundArr2,fundArr2024501,fundArr2024502,fundArr2024503,fundArr2024504,fundArr2024505,fundArr2024506,
        fundArr2024507,fundArr2024508,fundArr2024509,fundArr2024510,fundArr2024511,fundArr2024512,
        fundArr2024513,fundArr2024514,fundArr2024515,fundArr2024516,fundArr2024517,fundArr2024518,
        fundArr2024519,fundArr2024520,fundArr2024521,fundArr2024522,fundArr2024523,fundArr2024524,
        fundArr2024525,fundArr2024526,fundArr2024527,fundArr2024528,fundArr2024529,fundArr2024530,
        fundArr3,fundArr4
      ];
      let e = this.menuOptions2.filter(item=>item.name === this.name)[0].id
      let nums = fundArrs[e - 1].fund.length > 100 ? 100 : fundArrs[e - 1].fund.length
      if(this.state){
        this.listData = this.processFundData(fundArrs[e - 1]); 
      }else{
        this.listData = this.getRand100(this.processFundData(fundArrs[e - 1]), nums);
      }
      // console.log('this.listData',this.listData)
      this.lastId = this.listData.length
      this.checked = "";
      this.labelDisabled = false;
      let items = this.listData;
      for (let i = 0; i < items.length; i++) {
        if (i === this.id) {
          this.title = (i + 1) + '、' + items[i].title;
          this.explain = items[i].explain.replace(/\n/g, '<br>');
          this.fundOptions = items[i].question;
          this.questions = items[i].questions ? items[i].questions : ''
          this.table = items[i].table ? items[i].table : ''
          this.antrue = items[i].answer;
          this.id = this.id + 1;
          return;
        }
      }
    },
    changeRadio(e) {
      if (e != "" && this.labelDisabled == false) {
        this.labelDisabled = true;
        let antrue = 1
        if(this.antrue === 'A'){
            antrue = 1;
          }else if(this.antrue === 'B'){
            antrue = 2;
          }else if(this.antrue === 'C'){
            antrue = 3;
          }else{
            antrue = 4;
          }
        if (e === Number(antrue)) {
          Notify({ type: "success", message: "答对了！", duration:2000 });
          this.score = this.score + 1
          if(!this.state){
            setTimeout(() => {
              this.getListData();
            }, 2000);
          }
        } else {
          Notify({ type: "danger", message: "错了，请看正确答案！", duration:2000 });
        }
      }
      setTimeout(() => {
        if (this.labelDisabled == true) {
          if(this.antrue === 'A'){
            this.checked = 1;
          }else if(this.antrue === 'B'){
            this.checked = 2;
          }else if(this.antrue === 'C'){
            this.checked = 3;
          }else{
            this.checked = 4;
          }
        }
      }, 1000);
    },
    getRand100(arr, count) {
      var shuffled = arr.slice(0),
        i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    clickNext() {
      if (this.id === this.listData.length) {
          Notify({ type: "success", message: "本轮刷题已完成，你的分数为" + this.score + "分，刷新页面开启新一轮刷题！" });
          this.btnLable = "已完成";
        }
        this.getListData();
    }
  }
};
</script>
<style lang="scss" scoped>
.fund {
  color: #fff;
  article{
    background: #2c2e2f;
    border-radius: 10px;
    padding: 30px 30px 10px;
    box-sizing: border-box;
    h3 {
      display: flex;
      justify-content: space-between;
      font-weight: normal;
      font-size: 24px;
      line-height: 42px;
      margin-bottom: 18px;
      text-align: left;
      border-bottom: 1px solid #252222;
      padding-bottom: 15px;
    }
    .van-radio,
    .van-checkbox {
      margin-top: 10px;
    }
    p {
      background: #f5f5f5;
      padding: 10px;
      text-align: left;
    }
    .explain{
      background: #f0eedf;
      padding: 15px;
      font-size: 16px;
      border-radius: 8px;
      color: #222;
      margin-top: 20px;
    }
  }
}
</style>
<style>
.fund article .van-radio__label, .questions{
  color: #fff;
  font-size: 20px;
  line-height: 32px;
  margin-left: 18px;
}
.questions{
  margin-top: 20px;
  margin-left: 5px;
  line-height: 40px;
}
.questions table {
    border-collapse: collapse;
    border-spacing: 0;
    border-collapse: collapse;
}
.questions table td{
  text-align: center;
  font-weight: normal;
}
.btn {
    display: block;
    width: 142px;
    background-color: #f1404b;
    box-shadow: 0 0 .2rem rgba(241, 64, 75, .1);
    padding: 8px 15px;
    border-radius: 30px;
    color: initial;
    font-size: 22px;
    text-align: center;
    margin: 30px 0;
    color: #fff;
    cursor: pointer;
}
.van-popup{
  padding: 35px!important;
  font-size: 18px!important;
}
.add{
  float: right;
}
@media screen and (max-width: 1000px) {
  .header h1{
    display: none;
  }
  .info{
    left: 0;
    right: 0;
    justify-content: center;
    font-size: 18px;
  }
  .fund article{
    padding: 20px 20px 10px!important;
  }
  .fund article h3{
    display: block!important;
    font-size: 21px!important;
    line-height: 35px!important;
  }
  .fund article span{
    display: block;
  }
  .fund article .van-radio__label, .questions{
    font-size: 18px;
    line-height: 32px;
  }
  .btn{
    margin: 30px auto;
  }
  .add{
    width: 100%;
    float: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Fund.vue